import { render } from "./OurSocialsPage.vue?vue&type=template&id=332974d3&scoped=true"
import script from "./OurSocialsPage.vue?vue&type=script&lang=js"
export * from "./OurSocialsPage.vue?vue&type=script&lang=js"

import "./OurSocialsPage.vue?vue&type=style&index=0&id=332974d3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332974d3"]])

export default __exports__